var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValve(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#595E62"
    },
    d: "M314.062,50.144c20.374,0,36.948,16.574,36.948,36.948c0,10.134-4.117,19.424-10.873,26.075 c-6.651,6.756-15.941,10.873-26.075,10.873h-21.113c-3.484,0-6.862-0.528-10.134-1.478C267.296,118.235,256,103.984,256,87.093 c0-10.134,4.117-19.424,10.873-26.075c6.651-6.756,15.941-10.873,26.075-10.873H314.062z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#595E62"
    },
    d: "M197.938,124.041c-20.374,0-36.948-16.574-36.948-36.948c0-10.134,4.117-19.424,10.873-26.075 c6.651-6.756,15.941-10.873,26.075-10.873h21.113c20.374,0,36.948,16.574,36.948,36.948c0,10.134-4.117,19.424-10.873,26.075 c-4.328,4.434-9.818,7.706-15.941,9.395c-3.273,0.95-6.651,1.478-10.134,1.478H197.938z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E8488"
    },
    d: "M256,87.093c0,16.891,11.296,31.142,26.814,35.471l-0.422,1.478v79.175h-52.783v-79.175l-0.422-1.478 c6.123-1.689,11.612-4.962,15.941-9.395C251.883,106.517,256,97.227,256,87.093z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AFB6BB"
    },
    points: "319.34,203.217 319.34,250.722 192.66,250.722 192.66,203.217 229.608,203.217  282.392,203.217 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0085BF"
    },
    points: "71.258,419.629 71.258,461.856 7.918,461.856 7.918,240.165 71.258,240.165 71.258,282.392  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0085BF"
    },
    points: "440.742,419.629 440.742,282.392 440.742,240.165 504.082,240.165 504.082,461.856  440.742,461.856  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 340.454,
    y: 282.392,
    style: {
      fill: "#00ABD5"
    },
    width: 100.289,
    height: 137.237
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.258,
    y: 282.392,
    style: {
      fill: "#00ABD5"
    },
    width: 100.289,
    height: 137.237
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0085BF"
    },
    d: "M340.454,451.299H171.546v-31.67V282.392v-31.67h21.113h126.68h21.113v31.67v137.237V451.299z  M303.505,414.351V287.67h-95.01v126.68H303.505z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.495,
    y: 287.67,
    style: {
      fill: "#7E8488"
    },
    width: 95.01,
    height: 126.68
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 71.258,
    y: 282.392,
    style: {
      fill: "#009DD3"
    },
    width: 100.289,
    height: 73.897
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.454,
    y: 282.392,
    style: {
      fill: "#009DD3"
    },
    width: 100.289,
    height: 73.897
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 229.608,
    y: 311.423,
    style: {
      fill: "#FFFFFF"
    },
    width: 52.784,
    height: 15.835
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.608,
    y: 343.093,
    style: {
      fill: "#FFFFFF"
    },
    width: 52.784,
    height: 15.835
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.608,
    y: 374.763,
    style: {
      fill: "#FFFFFF"
    },
    width: 21.113,
    height: 15.835
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.278,
    y: 374.763,
    style: {
      fill: "#FFFFFF"
    },
    width: 21.113,
    height: 15.835
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M432.825,232.247v42.227h-84.454v-31.67h-21.113v-47.505h-36.948v-63.437c0.881,0.055,1.762,0.097,2.639,0.097h21.113 c12.03,0,23.276-4.685,31.673-13.192c8.509-8.398,13.193-19.645,13.193-31.674c0-24.74-20.126-44.866-44.866-44.866h-21.113 c-12.03,0-23.276,4.685-31.673,13.192c-1.969,1.943-3.723,4.045-5.272,6.269c-8.099-11.744-21.638-19.46-36.952-19.46h-21.113 c-12.03,0-23.276,4.685-31.673,13.192c-8.508,8.398-13.193,19.645-13.193,31.674c0,24.74,20.126,44.866,44.866,44.866h21.113 c0.877,0,1.758-0.041,2.639-0.096v63.436h-36.948v47.505h-21.113v31.67H79.175v-42.227H0v237.526h79.175v-42.227h84.454v31.67 h184.742v-31.67h84.454v42.227H512V232.247H432.825z M237.526,127.93c4.926-2.211,9.421-5.308,13.212-9.175 c1.965-1.94,3.715-4.039,5.26-6.258c4.584,6.667,10.94,12.068,18.476,15.444v67.357h-36.948V127.93z M272.428,66.66l0.088-0.088 c5.402-5.488,12.659-8.511,20.432-8.511h21.113c16.007,0,29.031,13.023,29.031,29.031c0,7.774-3.022,15.031-8.511,20.432 l-0.088,0.088c-5.402,5.488-12.659,8.511-20.432,8.511h-21.113c-2.6,0-5.266-0.392-8.007-1.187 c-12.379-3.453-21.024-14.903-21.024-27.844C263.918,79.319,266.94,72.062,272.428,66.66z M197.938,116.124 c-16.007,0-29.031-13.023-29.031-29.031c0-7.774,3.022-15.031,8.511-20.432l0.088-0.088c5.402-5.488,12.659-8.511,20.433-8.511 h21.113c16.007,0,29.031,13.023,29.031,29.031c0,7.774-3.022,15.031-8.511,20.432l-0.11,0.111 c-3.391,3.473-7.673,5.995-12.382,7.295l-0.102,0.029c-2.661,0.772-5.327,1.164-7.927,1.164 C219.05,116.124,197.938,116.124,197.938,116.124z M200.577,211.134h110.845v31.67H200.577V211.134z M63.34,453.938H15.835V248.082 H63.34V453.938z M79.175,411.711V290.309h84.454v121.402H79.175z M332.536,443.381H179.464V258.639h153.072V443.381z  M348.371,411.711V290.309h84.454v121.402H348.371z M496.165,453.938H448.66V248.082h47.505V453.938z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200.577,422.268h110.845V279.753H200.577V422.268z M216.412,295.588h79.175v110.845h-79.175V295.588z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 31.67,
    y: 303.505,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.835,
    height: 150.56
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.495,
    y: 303.505,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.835,
    height: 150.56
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.66,
    y: 79.175,
    style: {
      fill: "#FFFFFF"
    },
    width: 31.67,
    height: 15.835
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.67,
    y: 79.175,
    style: {
      fill: "#FFFFFF"
    },
    width: 31.67,
    height: 15.835
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.649,
    y: 311.423,
    style: {
      fill: "#FFFFFF"
    },
    width: 47.505,
    height: 15.835
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.845,
    y: 311.423,
    style: {
      fill: "#FFFFFF"
    },
    width: 47.505,
    height: 15.835
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValve);
export default __webpack_public_path__ + "static/media/valve.2a5562dd349a05f2607fb932a0623e49.svg";
export { ForwardRef as ReactComponent };